import font from './font.json';
export const FONT_INTER: string = font.inter;
